<div class="dashboard-charts p-d-flex">
    <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
    <div style="flex-grow:1; width:100%">
        <p-chart type="bar" height="95%" [data]="barChartData" [options]="barChartbasicOptions"></p-chart>
        <p style="text-align: center;" class="p-mb-0">{{chartBottomLabel}}</p>
    </div>
</div>

<p-dialog [header]="filterPopupHeader" (onHide)="cancelFilterPopup()" [(visible)]="displayFilterPopup" [modal]="true"
    [style]="{width: '400px'}" appendTo="body">
    <ng-template pTemplate="content">
        <form [formGroup]="filterForm" novalidate>
            <div class="p-grid" style="flex-grow: 1;">
                <div class="p-col-12">
                    <h6 class="p-mb-1">Select Period</h6>
                    <p-dropdown [options]="filterDataByTime" (onChange)="changeRange($event)"
                         id="rangeItems" [style]="{'width':'100%'}"
                        formControlName="selectedDateFilter" optionLabel="label" appendTo="body"
                        placeholder="Select Date">
                    </p-dropdown>
                    <div *ngIf="detailsFormErrors?.selectedDateFilter" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedDateFilter }}</small>
                    </div>
                </div>
                <ng-container *ngIf="filterForm.value.selectedDateFilter?.code=='custom'">
                    <div class="p-col-12">
                        <h6 class="p-mb-1">From Date</h6>
                        <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                            dateFormat="mm/dd/yy" yearRange="1900:2100"
                            formControlName="dateFrom" [maxDate]="filterForm.getRawValue().dateTo"
                            [disabled]="filterForm.value.selectedDateFilter?.code !== 'custom'" [style]="{'width':'100%'}"
                            [inputStyle]="{'width':'100%'}">
                        </p-calendar>
                    </div>
                    <div class="p-col-12">
                        <h6 class="p-mb-1">To Date</h6>
                        <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                            dateFormat="mm/dd/yy" yearRange="1900:2100"
                            formControlName="dateTo" [minDate]="filterForm.getRawValue().dateFrom"
                            [disabled]="filterForm.value.selectedDateFilter?.code !== 'custom'" [style]="{'width':'100%'}"
                            [inputStyle]="{'width':'100%'}">
                        </p-calendar>
                    </div>
                </ng-container>
            </div>
        </form>
    </ng-template>
    <p-footer>
        <button type="button" pButton label="Cancel" (click)="cancelFilterPopup()" class="p-button-secondary"></button>
        <button type="submit" pButton label="Apply"
            (click)="applyAllFilters(reportsAllFiltersApplyModes.applyOnly)"></button>
        <button type="submit" pButton label="Apply & Save"
            (click)="applyAllFilters(reportsAllFiltersApplyModes.applySave)"></button>
    </p-footer>
</p-dialog>
